__turbopack_context__.v({
  "img": "InfoSectionBlock-module-scss-module__z-hFVG__img",
  "item": "InfoSectionBlock-module-scss-module__z-hFVG__item",
  "list": "InfoSectionBlock-module-scss-module__z-hFVG__list",
  "section": "InfoSectionBlock-module-scss-module__z-hFVG__section",
  "subtitle": "InfoSectionBlock-module-scss-module__z-hFVG__subtitle",
  "textWrapper": "InfoSectionBlock-module-scss-module__z-hFVG__textWrapper",
  "title": "InfoSectionBlock-module-scss-module__z-hFVG__title",
});
